// This file is automatically generated. Do not edit manually.

import { CustomerOrderOfferProfitMarginView } from "src/api/generated/erp/db/types/tables/customerOrderOfferProfitMarginView";
import { PriceRecalculationResult } from "src/api/generated/erp/sales/pricing/service/priceRecalculationResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderOfferProfitMarginApi {
	export async function getProfitMargins(args: {
		customerOrderOfferId: number;
	}): Promise<Array<CustomerOrderOfferProfitMarginView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/profitMargins/getProfitMargins",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as Array<CustomerOrderOfferProfitMarginView>;
	}

	export async function saveProfitMargins(args: {
		customerOrderOfferId: number;
		rows: Array<CustomerOrderOfferProfitMarginApi_SaveRow>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/profitMargins/saveProfitMargins",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
				rows: args.rows,
			},
		});
		return response as void;
	}

	export async function recalculatePrices(args: { customerOrderOfferId: number }): Promise<PriceRecalculationResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/profitMargins/recalculatePrices",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as PriceRecalculationResult;
	}

	export async function acknowledgePriceRecalculation(args: { customerOrderOfferId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/profitMargins/acknowledgePriceRecalculation",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as void;
	}
}

export interface CustomerOrderOfferProfitMarginApi_SaveRow {
	profitMarginPercent: number | null | undefined;
	salesPartPriceGroupId: number;
}
